// import injectTapEventPlugin from 'react-tap-event-plugin';
import { createTheme } from "@mui/material/styles";

// WORKAROUND Some components use react-tap-event-plugin to listen for touch events
// https://www.npmjs.com/package/material-ui#react-tap-event-plugin
// injectTapEventPlugin();

const primary1Color = "#A826EE";
const primary2Color = "#000";
const colorDanger = "#D50000";

const configureTheme = createTheme({
  palette: {
    mode: "light",
    primary1Color,
    accent1Color: "#000",
    borderColor: "#BFC0C0",
    textColor: "#000",
    secondaryTextColor: "#212121",
    custom: {
      colorDanger,
    },
  },
  tabs: {
    selectedTextColor: primary2Color,
    backgroundColor: "#fff",
    textColor: "#000",
  },
  inkBar: {
    backgroundColor: primary1Color,
  },
  subheader: {
    color: primary1Color,
  },
  drawer: {
    width: 300,
  },
});

export default configureTheme;
